import { render, staticRenderFns } from "./select-month.vue?vue&type=template&id=897dbc06"
import script from "./select-month.vue?vue&type=script&lang=js"
export * from "./select-month.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports